import { Card, CardBody, CardHeader, Select } from '@/components/ui';
import { useTheme, type ThemePreference } from '@/stores/theme';

export function PreferencesCard() {
  const { preference, setPreference } = useTheme();

  return (
    <Card>
      <CardHeader>
        <h2 className="font-semibold">Preferences</h2>
      </CardHeader>
      <CardBody className="space-y-4">
        <Select
          label="Appearance"
          value={preference}
          onChange={(event) => setPreference(event.target.value as ThemePreference)}
          options={[
            { value: 'light', label: 'Light' },
            { value: 'dark', label: 'Dark' },
            { value: 'system', label: 'System' },
          ]}
          aria-describedby="appearance-description"
        />
        <p id="appearance-description" className="text-sm text-gray-500 dark:text-gray-400">
          Saved in this browser. System follows your device’s appearance.
        </p>
        <div className="border-t border-gray-200 dark:border-gray-700 pt-4 space-y-4">
          <label className="flex items-center justify-between gap-4">
            <span>
              <span className="block font-medium">Email Notifications</span>
              <span className="block text-sm text-gray-500 dark:text-gray-400">
                Receive email notifications for task assignments and updates
              </span>
            </span>
            <input type="checkbox" disabled defaultChecked className="h-4 w-4 rounded" />
          </label>
          <label className="flex items-center justify-between gap-4">
            <span>
              <span className="block font-medium">Weekly Digest</span>
              <span className="block text-sm text-gray-500 dark:text-gray-400">
                Receive a weekly summary of your time tracking
              </span>
            </span>
            <input type="checkbox" disabled defaultChecked className="h-4 w-4 rounded" />
          </label>
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Email preferences are not yet functional. Coming soon!
          </p>
        </div>
      </CardBody>
    </Card>
  );
}
